import script from "./EditCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCreator.vue?vue&type=script&setup=true&lang=js"

import "./EditCreator.vue?vue&type=style&index=0&id=34e18a45&lang=scss"

const __exports__ = script;

export default __exports__